export type ChallengeStatus = 'pending' | 'accepted' | 'declined' | 'cancelled';

export interface Challenge {
  id: string;
  challengerId: string;
  challengedId: string;
  tournamentId?: string;
  status: ChallengeStatus;
  message?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ChallengeWithUser extends Challenge {
  userName?: string;
  userEmail?: string;
  userAvatarUrl?: string;
}
